import { useState, useEffect } from 'react'

type State<T> = {
  data: T | null
  loading: boolean
  error: string | null
}

type UseSanityFetchOptions = {
  enabled?: boolean
}

export function useSanityFetch<T>(
  fetcher: () => Promise<T>,
  deps: unknown[] = [],
  options: UseSanityFetchOptions = {},
): State<T> {
  const enabled = options.enabled ?? true
  const [state, setState] = useState<State<T>>({
    data: null,
    loading: enabled,
    error: null,
  })

  useEffect(() => {
    if (!enabled) {
      setState({ data: null, loading: false, error: null })
      return
    }

    let cancelled = false

    setState({ data: null, loading: true, error: null })

    fetcher()
      .then((data) => {
        if (!cancelled) setState({ data, loading: false, error: null })
      })
      .catch((err: unknown) => {
        if (!cancelled) {
          const message = err instanceof Error ? err.message : 'Failed to load'
          setState({ data: null, loading: false, error: message })
        }
      })

    return () => {
      cancelled = true
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [...deps, enabled])

  return state
}
